/**
 * Crisis Triage Lesson
 * Skill Area: Operations
 * Prioritize effectively under high pressure
 */

import type { LessonDefinition } from '../types';
import { CRISIS_TRIAGE_AI_PROMPT } from '../prompts/crisis-triage.prompt';

export const crisisTriage: LessonDefinition = {
  id: 'crisis-triage',
  title: 'Crisis Triage',
  displayTitle: 'Prioritize Effectively Under High Pressure',
  subTitle: 'Rank competing fires by impact vs. urgency.',
  tagline: 'Decide what matters most when everything is burning.',
  persona: 'Lyra',
  skillArea: 'Operations',
  format: 'scenario',
  difficulty: 'Advanced',
  estimatedMinutes: 8,
  tags: ['triage', 'decisions', 'prioritization'],
  dailyEligible: true,
  releasedAt: '2025-03-10T00:00:00.000Z',
  route: '/micro/crisis-triage',
  storyBeat: 'Lyra pushes you to choose impact over noise.',
  learningMode: 'triage',
  introPrompt: "When everything feels urgent, nothing gets done well. One bad prioritization can derail your whole week. Let's fix that.",
  steps: [
    "Identify where competing demands cause the most damage",
    "Learn the Impact vs. Urgency framework",
    "Practice triaging realistic crisis scenarios",
    "Master your personalized prioritization checklist"
  ],
  promptGuidance: 'Choose a crisis type below or type your own.',
  aiPrompt: CRISIS_TRIAGE_AI_PROMPT,
  inputPlaceholder: "e.g., Conflicting deadlines, stakeholder emergencies...",
  quickPrompts: [
    'Board meeting prep vs. grant deadline',
    'Donor crisis vs. staff emergency',
    'Tech failure vs. event logistics'
  ]
};
